import { useContext } from "react";
import { faComment } from "@fortawesome/free-solid-svg-icons";

import { ChatContext } from "components/Chat/ChatContext";
import { MenuButton } from "types-and-validators/MenuButton";

interface Partner {
	uid: string;
	displayName: string;
}

export function useMenuButtonOpenChat() {
	const [, setChatDetails] = useContext(ChatContext);

	return ({ uid, displayName }: Partner) => {
		const output: MenuButton = {
			onClick: () =>
				setChatDetails({
					partner: { uid, displayName },
					pagination: {
						cursorType: "after"
					}
				}),
			label: "Open chat",
			icon: faComment
		};

		return output;
	};
}
